import { Component, OnInit, Output, Injectable , EventEmitter} from '@angular/core';
import { Router }            from '@angular/router';
import { Http ,RequestOptions}       from '@angular/http';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import { routerTransition } from '../../router.animations';
 

 import {Headers} from '@angular/http';
// Observable class extensions
import 'rxjs/add/observable/of';
 
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/toPromise';
 import { URLSearchParams } from '@angular/http'; 
//import { Migration } from './migration';
import { LayoutService} from '../layout.service';
import { ALLOW_MULTIPLE_PLATFORMS } from '@angular/core/src/application_ref';

import { Notification }           from './notification';

import { LoginService} from '../../login/login.service';
import { environment } from 'environments/environment';
 
@Injectable()




export class UpdateNotificationService {



  @Output () public notificationsUpdateEvent = new EventEmitter <any> ();

  notificationURL:string =environment.apiRoot+'UpdateNotificationRead';
 
  data:any ={};
  private headers = new Headers({'Content-Type': 'application/json'});


  
  constructor(private http: Http, private loginService:  LoginService) {


  }
 
GetNotifications (): Array<Notification> {


  console.debug( this.loginService.agent.notifications);;

  return this.loginService.agent.notifications as Array< Notification>;
  
  

}

UpdateAgentNotifications (notification: any) : Promise<any> {

        // update notifcation read state

        let promise = new Promise (  ( resolve, reject ) =>
        { 
 

            this.UpdateNotification (true,  notification.id).then ( 


              data => {

            
                for ( let i= 0; i< this.loginService.agent.notifications.length; i++) {
           
                  if ( this.loginService.agent.notifications[i].id == notification.id)  {
                   
                    this.loginService.agent.notifications[i].notificationCleared=true;
                 

                  //  this.notificationsUpdateEvent.emit(-1);
                    this.loginService.AgentProfileUpdated();
                    
                    break;
        
                  }
                }
               

                // emit the change to subscribers;

                
                  this.notificationsUpdateEvent.emit( this.loginService.agent.notifications);
              
              
                resolve(); // resolve promise
 
               
            }). catch ( error => reject());
        });

      return promise;

}


UpdateNotification( read: boolean,  notificationId: string) : Promise<any>  { 
   
 

  console.log( this.notificationURL + " id: " + notificationId);

  let update = new NotificationUpdate ( this.loginService.agent.id, notificationId);

  return this.http.post(this.notificationURL, JSON.stringify( update) , {headers: this.headers} )
.toPromise();



      }
    

    }
    export class NotificationUpdate {
      public notificationId: string;
      public id: string;
      
     constructor (idIn:string, notificationIdIn:string) {
        this.notificationId=notificationIdIn;
        this.id= idIn;

      }
    }


// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/layout/notifications-page/update-notification.service.ts